module.exports = __webpack_public_path__ + "img/beer_id-8.dbe3c640.jpg";